import { render, staticRenderFns } from "./watermarkSet.vue?vue&type=template&id=39912f11&scoped=true&"
import script from "./watermarkSet.vue?vue&type=script&lang=js&"
export * from "./watermarkSet.vue?vue&type=script&lang=js&"
import style0 from "./watermarkSet.vue?vue&type=style&index=0&lang=less&"
import style1 from "./watermarkSet.vue?vue&type=style&index=1&id=39912f11&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39912f11",
  null
  
)

export default component.exports